import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').controller('NewQuickFilterCtrl', NewQuickFilterCtrl);

    function NewQuickFilterCtrl(
        $rootScope,
        platformSettingsService,
        NetworkPoint,
        NETWORK_POINT_SEARCH_MODE
    ) {
        var vm = this;

        vm.NETWORK_POINT_SEARCH_MODE = NETWORK_POINT_SEARCH_MODE;
        vm.newQuickFilterForm = {};
        vm.newQuickFilter = {};
        vm.selectedNetworkPoints = [];
        vm.DIRECTION = platformSettingsService.DIRECTION;
        vm.addNetworkPoints = addNetworkPoints;
        vm.submitQuickFilter = submitQuickFilter;
        vm.removeFavoriteNetworkPoint = removeFavoriteNetworkPoint;
        vm.cancel = cancel;

        function addNetworkPoints(selectedNetworkPoints, isFromQuickfilter) {
            vm.selectedNetworkPoints = selectedNetworkPoints;
        }

        function submitQuickFilter() {
            var selectedNetworkPointsWithoutCustomFlags = [];
            var tmpNetworkPoint;

            for (var i = 0; i < vm.selectedNetworkPoints.length; i++) {
                tmpNetworkPoint = angular.copy(vm.selectedNetworkPoints[i]);
                delete tmpNetworkPoint._favorite;
                selectedNetworkPointsWithoutCustomFlags.push(tmpNetworkPoint);
            }

            vm.newQuickFilterForm.$setSubmitted(true);
            if (!vm.newQuickFilterForm.$valid) {
                return false;
            }
            NetworkPoint.addQuickFilter(
                {
                    name: vm.newQuickFilter.name,
                    networkPointList: selectedNetworkPointsWithoutCustomFlags
                },
                function () {
                    $rootScope.$broadcast(
                        platformSettingsService.BROADCAST.NEW_QUICK_FILTER,
                        {
                            name: vm.newQuickFilter.name,
                            selectedNetworkPoints:
                                selectedNetworkPointsWithoutCustomFlags
                        }
                    );
                },
                function () {
                    $rootScope.$broadcast(
                        platformSettingsService.BROADCAST.NEW_QUICK_FILTER,
                        {
                            error: true
                        }
                    );
                }
            );
        }

        function removeFavoriteNetworkPoint(networkPoint) {
            vm.selectedNetworkPoints.splice(
                vm.selectedNetworkPoints.indexOf(networkPoint),
                1
            );
        }

        function cancel() {
            $rootScope.$broadcast(
                platformSettingsService.BROADCAST.CANCEL_NEW_QUICK_FILTER
            );
        }
    }
})();
